import {
  ADD_TO_CART,
  ADD_COMBO_TO_CART,
  REMOVE_PRODUCT_FROM_CART,
  INCREMENT_PRODUCT,
  DECREMENT_PRODUCT,
  VALIDATE_CART_REQUEST,
  VALIDATE_CART_SUCCESS,
  VALIDATE_CART_FAILURE,
  CHANGE_TIP_PERCENTAGE,
  CHANGE_SPECIAL_INSTRUCTIONS,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  INVALIDATE_CART,
  TOGGLE_PRODUCT_IS_FAVOURITED,
  UNFAVOURITE_BY_FAVOURITE_ID,
  SET_IS_FOR_PREVIEW,
  INVALID_TIP_AMOUNT,
  RESET_INVALID_TIP_FLAG,
  INITIALIZE_VALIDATE_CART_WITH_NULL,
  EMPTY_CART,
  REMOVE_COMBO_FROM_CART,
  UPDATE_CART_PRODUCTS,
} from './cartTypes';
import {
  RESET_ORDER_SETTING_TIME_SETTINGS,
  DELIVERY,
  DROPOFF,
  PICKUP,
} from '../OrderSetting/orderSettingTypes';
import {formatSelectedDateTime} from '../OrderSetting/orderSettingActions';
import api, {oldYork} from '../../api';
import isValidCreditCard from '../../utils/isValidCreditCard';
import {createAlert} from '../Alert/alertActions';
import flattenProduct from '../../utils/flattenProduct';
import calculatePrice from '../../utils/calculatePrice';
import {getPaymentMethods} from '../PaymentMethods/paymentMethodsActions';

const PATTERN_PAYLOAD = '$$PAYLOAD$$';

export function addToCart(product, notFavourite) {
  return {
    type: ADD_TO_CART,
    product: notFavourite
      ? {...product, isFromFavourite: false, favouriteId: null}
      : product,
  };
}

export const addComboToCart = comboData => {
  return {
    type: ADD_COMBO_TO_CART,
    comboData,
  };
};

export function initializeValidateCartWithNull() {
  return {
    type: INITIALIZE_VALIDATE_CART_WITH_NULL,
  };
}

export function removeProductFromCart(productIndexInCart) {
  return {
    type: REMOVE_PRODUCT_FROM_CART,
    productIndexInCart,
  };
}

export const removeComboFromCart = comboIndexInCart => {
  return dispatch => {
    dispatch({
      type: REMOVE_COMBO_FROM_CART,
      comboIndexInCart,
    });
  };
};

export function incrementProduct(productIndexInCart) {
  return {
    type: INCREMENT_PRODUCT,
    productIndexInCart,
  };
}

export function decrementProduct(productIndexInCart) {
  return {
    type: DECREMENT_PRODUCT,
    productIndexInCart,
  };
}

export function emptyCart() {
  return function(dispatch) {
    dispatch({type: EMPTY_CART});
  };
}
export function validateCart(cart) {
  return function(dispatch, getState) {
    const {tipPercentage} = getState().cartReducer;
    dispatch({type: VALIDATE_CART_REQUEST});
    return api.post('/cart/validate', {...cart}).then(
      response => {
        let validatedFlatProducts = [];
        response.data.data.products.map(product => {
          let flatProduct = flattenProduct({
            ...product,
            options: product.options || [],
          });
          flatProduct.name = product.name;
          const price = calculatePrice(flatProduct);

          validatedFlatProducts.push({...flatProduct, ...price});
        });

        dispatch({
          type: VALIDATE_CART_SUCCESS,
          tipPercentage: tipPercentage,
          response: {
            ...response.data.data,
            validatedFlatProducts: validatedFlatProducts,
          },
          requestedCart: cart,
        });
      },
      error => {
        dispatch({type: VALIDATE_CART_FAILURE, error});
      }
    );
  };
}

export function changeTipPercentage(tip) {
  return function(dispatch, getState) {
    const {requestedCart} = getState().cartReducer;

    let tipAmount = tip;
    if (requestedCart.tip === tip) {
      tipAmount = 0;
    }

    return api
      .post(`/cart/validate`, {...requestedCart, tip: tipAmount})
      .then(response => {
        let validatedFlatProducts = [];
        response.data.data.products.map(product => {
          let flatProduct = flattenProduct({
            ...product,
            options: product.options || [],
          });
          flatProduct.name = product.name;
          const price = calculatePrice(flatProduct);

          validatedFlatProducts.push({...flatProduct, ...price});
        });

        dispatch({
          type: CHANGE_TIP_PERCENTAGE,
          tipPercentage: tipAmount,
          response: {
            ...response.data.data,
            validatedFlatProducts: validatedFlatProducts,
          },
        });
      });
  };
}

export function changeSpecialInstructions(specialInstructions) {
  return {
    type: CHANGE_SPECIAL_INSTRUCTIONS,
    specialInstructions,
  };
}

export function placeOrder(orderConfig) {
  return function(dispatch, getState) {
    orderConfig = {...orderConfig, tip: getState().cartReducer.tipPercentage};
    const coords = getState().locationsReducer.currentLocation;

    if (coords) {
      orderConfig = {
        ...orderConfig,
        latitude: coords.latitude,
        longitude: coords.longitude,
      };
    } else {
      orderConfig = {
        ...orderConfig,
        latitude: 0,
        longitude: 0,
      };
    }
    const creditCard = getState().paymentMethodsReducer.paymentMethods.find(
      card => card.is_preferred
    );

    if (
      creditCard.type !== 'gift_card' &&
      creditCard.details.expiry_date.slice(5, 7) > 12
    ) {
      return dispatch(
        createAlert({type: 'error', message: 'Invalid Expiry Date'})
      );
    }
    if (
      creditCard.type !== 'gift_card' &&
      !isValidCreditCard(
        creditCard.details.expiry_date.slice(5, 7),
        creditCard.details.expiry_date.slice(0, 4)
      )
    ) {
      return dispatch(
        createAlert({type: 'error', message: 'Expired Credit Card'})
      );
    }
    dispatch({type: PLACE_ORDER_REQUEST});
    return api.post('/payment-code').then(response => {
      // get address
      const customer_address_id =
        getState().orderSettingReducer.orderType === DELIVERY
          ? getState().orderSettingReducer.deliveryDetails.id
          : null;

      // get dropoff location
      const dropOffLocation =
        getState().orderSettingReducer.orderType === DROPOFF
          ? getState().orderSettingReducer.dropOffDetails.id
          : null;
      // make base body
      let qr_code = response.data.data.pattern;
      qr_code = qr_code.replace(
        PATTERN_PAYLOAD,
        response.data.data.payment_code
      );

      let body = {
        ...orderConfig,
        qr_code,
      };
      // if delivery address, add it
      if (customer_address_id) {
        body = {
          ...body,
          customer_address_id,
        };
      }
      api.post('/orders', body).then(
        response => {
          let placedOrder = {
            ...response.data.data,
          };
          if (customer_address_id) {
            let deliveryAddress = getState().deliveryAddressesReducer.deliveryAddressesList.find(
              deliveryAddress => deliveryAddress.id === customer_address_id
            );
            placedOrder = {
              ...placedOrder,
              orderType: DELIVERY,
              address: deliveryAddress,
            };
          } else if (dropOffLocation) {
            let dropOffLocation = getState().dropOffLocationReducer
              .selectedDropOffLocation;
            placedOrder = {
              ...placedOrder,
              orderType: DROPOFF,
              address: [...dropOffLocation],
            };
          } else {
            let businessAddress = getState().locationsReducer.locations.find(
              location => location.id === orderConfig.business_id
            );
            placedOrder = {
              ...placedOrder,
              orderType: PICKUP,
              address: businessAddress,
            };
          }

          dispatch({
            type: PLACE_ORDER_SUCCESS,
            response: placedOrder,
          });
          // dispatch({
          //   type: RESET_ORDER_SETTING_TIME_SETTINGS,
          //   dateTimeToShow: formatSelectedDateTime(),
          // });
          dispatch(getPaymentMethods());
        },
        error => {
          dispatch({
            type: PLACE_ORDER_FAILURE,
            error,
          });
        }
      );
    });
  };
}

export function toggleProductIsFavourited(productIndexInCart, favouriteId) {
  return {
    type: TOGGLE_PRODUCT_IS_FAVOURITED,
    productIndexInCart,
    favouriteId,
  };
}

export function unfavouriteByFavouriteId(favouriteId) {
  return {
    type: UNFAVOURITE_BY_FAVOURITE_ID,
    favouriteId,
  };
}

export function invalidateCart() {
  return {
    type: INVALIDATE_CART,
  };
}

export function setIsForPreview(isForPreview) {
  return {
    type: SET_IS_FOR_PREVIEW,
    isForPreview,
  };
}

export function resetInvalidTip() {
  return function(dispatch) {
    dispatch({type: RESET_INVALID_TIP_FLAG});
  };
}
export function updateCartWithFavouritedProducts(products) {
  return function(dispatch) {
    dispatch({type: UPDATE_CART_PRODUCTS, products});
  };
}

export function updateCartWithUnavailbleProducts(unavaliableProductIds) {
  return function(dispatch, getState) {
    let products = getState().cartReducer.products;
    let combos = getState().cartReducer.combos;
    products = products.filter(product => {
      return !unavaliableProductIds.includes(product.flatProduct.product_id);
    });
    combos = combos.filter(combo => {
      return !unavaliableProductIds.includes(combo.id);
    });
    dispatch({type: UPDATE_CART_PRODUCTS, products, combos});
    dispatch({type: 'UPDATE_CART_COMBOS', combosModified: combos});
  };
}

export function updateCartNewPrices(newCart) {
  return function(dispatch) {
    dispatch({type: 'UPDATE_CART_NEW_PRICES', newCart});
  };
}
